import React, { useState } from "react";
import PizZip from "pizzip";
import Docxtemplater from "docxtemplater";
import { saveAs } from "file-saver";

function FormPage() {
  const [formData, setFormData] = useState({
    name: "",
    address: "",
    college: "",
    submitted: "yet", // Default value
    people: [
      { name: "", usn: "", email: "" },
    ],
  });

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handlePersonChange = (index, field, value) => {
    setFormData((prev) => {
      const updatedPeople = prev.people.map((person, i) =>
        i === index ? { ...person, [field]: value } : person
      );
      return { ...prev, people: updatedPeople };
    });
  };

  const addPerson = () => {
    setFormData((prev) => ({
      ...prev,
      people: [...prev.people, { name: "", usn: "", email: "" }],
    }));
  };

  const removePerson = (index) => {
    setFormData((prev) => ({
      ...prev,
      people: prev.people.filter((_, i) => i !== index),
    }));
  };

  const generateDocument = async () => {
    const response = await fetch("/template.docx");
    const arrayBuffer = await response.arrayBuffer();
    const zip = new PizZip(arrayBuffer);
    const doc = new Docxtemplater(zip, {
      paragraphLoop: true,
      linebreaks: true,
    });

    doc.setData({
      ...formData,
      submitted_yes: formData.submitted === "yes",
      submitted_no: formData.submitted === "no",
      submitted_yet: formData.submitted === "yet",
    });

    try {
      doc.render();
      const blob = doc.getZip().generate({
        type: "blob",
        mimeType:
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });
      saveAs(blob, "generated.docx");
    } catch (error) {
      console.error("Docxtemplater render error:", error);

      const e = {
        message: error.message,
        name: error.name,
        stack: error.stack,
        properties: error.properties,
      };

      console.log(JSON.stringify({ error: e }, null, 2));
    }
  };

  return (
    <div className="max-w-md mx-auto mt-10 bg-white p-6 rounded shadow">
      <label className="block mb-2 font-semibold">Name:</label>
      <input
        type="text"
        name="name"
        className="border p-2 w-full mb-4"
        value={formData.name}
        onChange={handleChange}
      />

      <label className="block mb-2 font-semibold">Address:</label>
      <input
        type="text"
        name="address"
        className="border p-2 w-full mb-4"
        value={formData.address}
        onChange={handleChange}
      />

      <label className="block mb-2 font-semibold">College:</label>
      <input
        type="text"
        name="college"
        className="border p-2 w-full mb-4"
        value={formData.college}
        onChange={handleChange}
      />

      <label className="block mb-2 font-semibold">Submitted document?</label>
      <div className="mb-4 flex gap-4">
        <label className="flex items-center">
          <input
            type="radio"
            name="submitted"
            value="yes"
            checked={formData.submitted === "yes"}
            onChange={handleChange}
            className="mr-2"
          />
          Yes
        </label>
        <label className="flex items-center">
          <input
            type="radio"
            name="submitted"
            value="no"
            checked={formData.submitted === "no"}
            onChange={handleChange}
            className="mr-2"
          />
          No
        </label>
        <label className="flex items-center">
          <input
            type="radio"
            name="submitted"
            value="yet"
            checked={formData.submitted === "yet"}
            onChange={handleChange}
            className="mr-2"
          />
          Yet to submit
        </label>
      </div>

      <h2 className="text-lg font-semibold mt-6 mb-2">People Details</h2>
      {formData.people.map((person, index) => (
        <div key={index} className="grid grid-cols-3 gap-4 mb-2">
          <input
            type="text"
            placeholder="Name"
            className="border p-2"
            value={person.name}
            onChange={(e) => handlePersonChange(index, "name", e.target.value)}
          />
          <input
            type="text"
            placeholder="USN"
            className="border p-2"
            value={person.usn}
            onChange={(e) => handlePersonChange(index, "usn", e.target.value)}
          />
          <input
            type="email"
            placeholder="Email"
            className="border p-2"
            value={person.email}
            onChange={(e) => handlePersonChange(index, "email", e.target.value)}
          />
          {formData.people.length > 1 && (
            <button
              onClick={() => removePerson(index)}
              className="text-red-600 col-span-3 text-left text-sm underline"
            >
              Remove
            </button>
          )}
        </div>
      ))}
      <button
        onClick={addPerson}
        className="bg-green-600 text-white px-3 py-1 rounded mt-2 w-full"
      >
        + Add Another Person
      </button>

      <button
        onClick={generateDocument}
        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 mt-4"
      >
        Generate Document
      </button>
    </div>
  );
}

export default FormPage;
